<div class="view">
  <!-- Content -->
  <div 
    class="view__content"
    [ngClass]="{'view__content--hidden': !(showColumn$ | async)}">
    
    <app-panel
      *ngIf="(selectedChapter$ | async)"
      [id]="id"
      [type]="type"
      [title]="(bookmark$ | async)?.title | textNormalize"
      [category]="category"
      [subtitle]="(selectedChapter$ | async)?.info.displayName | textNormalize">

      <app-column [selectedColumnGroup]="selectedColumnGroup" [showHeader]="false">
        
        <!-- Description -->
        <app-column-group label="Description">
          <ng-container column-group-body>
            <div class="view__article" [innerHTML]='(selectedChapter$ | async)?.info.description'></div>
          </ng-container>
        </app-column-group>

        <!-- Anatomy -->
        <app-column-group label="Anatomy">
          <!-- Anatomy Search -->
          <ng-container column-group-header>
            <div class="view__search">
              <input
                type="text"
                class="input w-100"
                placeholder="Search Anatomy..."
                (keyup)="handleSearchKeyup($event)"
                [formControl]="searchControl"
                #searchInput>

              <button
                app-button
                buttonType="text"
                buttonTheme="light"
                class="navigation-context__clear"
                (click)="clearSearchQuery()"
                *ngIf="query"
                class="view__search-clear">Clear</button>
            </div>
          </ng-container>

          <!-- Anatomy Search Results -->
          <ng-container column-group-body>
            <div class="pt-2 pl-2 flex-grow flex-column" [ngStyle]="{'display': (query.length ? 'flex' : 'none') }">
              <app-tree-search
                [theme]="treeTheme.Light"
                [query]="query"
                [viewGraph]="viewGraph$ | async">
              </app-tree-search>
            </div>

            <!-- Anatomy Tree -->
            <div class="pt-2 ph-2 flex-grow flex-column" [ngStyle]="{'display': (query.length ? 'none' : 'flex') }">
              <app-tree *ngIf="!query.length" [theme]="treeTheme.Light">
              </app-tree>
            </div>
          </ng-container>
        </app-column-group>

        <!-- Chapters -->
        <app-column-group label="Chapters">
          <ng-container column-group-body>
            <div class="pb-2 pl-2">
              <!-- Chapters -->
              <app-view-chapters-list></app-view-chapters-list>
            </div>
          </ng-container>
        </app-column-group>
        
      </app-column>
    </app-panel>
  </div>

  <!-- Engine-->
  <div class="view__scene" #engineContainer>
    <div class="view__collapse" (click)="handleCollapseClick()" *ngIf="(selectedChapter$ | async)">
      <fa-icon class="view__collapse-icon rotate--animate" [ngClass]="{'rotate-180': !(showColumn$ | async)}" icon="caret-left"></fa-icon>
    </div>

    <app-engine-camera-bar class="view__camera-bar"></app-engine-camera-bar>
    <app-engine-tool-bar class="view__tool-bar"></app-engine-tool-bar>
  </div>
</div>

<div class="view__drawer">
  <app-view-chapters-drawer></app-view-chapters-drawer>
</div>